import { HostActionEnum, IVanHost, RequestHostAction, ResultHostAction } from './types';

export const HostActionCreators = {
  getHost: (id: string): RequestHostAction => ({
    type: HostActionEnum.REQUEST_HOST,
    id
  }),
  resultGetHost: (data: IVanHost, status: string | number): ResultHostAction => ({
    type: HostActionEnum.RESULT_HOST,
    data,
    status
  })
};
